import {api} from "@/shared/api";

import {TaskDropdown} from "@/shared/task/taskDropdown";
import * as BootstrapModal from "@/shared/ui/bootstrapModal";
import {formatDate, getISODate, parseDateInput, Temporal} from "@/shared/utils/datefunctions";
import {Task} from "@/shared/timr";
import {BaseTreeNodeData} from "@/shared/ui/baseTree";

export class LockTaskDialog {

	public static EVENT_TASK_LOCKED = "taskLocked";

	private container: JQuery;
	private dialog: BootstrapModal.Modal;
	private taskDropdown: TaskDropdown;

	constructor(container: JQuery) {
		this.container = container;
		this.init();
	}

	public show(task: Task) {
		this.dialog.show();
		this.container.find(".dueDate").val(formatDate(this.getDefaultDate())).focus();
		if (task && !task.disabled) {
			this.taskDropdown.setSelectedTask(task);
		}
	}

	public hide() {
		this.dialog.close();
	}

	private init() {
		this.dialog = new BootstrapModal.Modal({
			title: "reports.lockTaskDialog.title",
			message: this.container,
			buttons: [{
				text: "dialog.lockPeriod",
				action: () => {
					this.lockPeriod();
				},
				css: "btn-primary"
			}, {
				text: "dialog.cancel"
			}]
		});
		this.taskDropdown = new TaskDropdown({
			rootElement: this.container.find(".taskDropdown"),
			allowSelectionOfNotBookable: true,
			hideInactive: true,
			emptyMessage: messages["reports.lockTaskDialog.task.all"],
			isNodeSelectable: (data: unknown) => {
				return this.isNodeSelectable(data as Task & BaseTreeNodeData);
			}
		}, {
			loadRootNodesURL: "reports/loadRootTasksForTaskLeader.json",
			loadSubNodesURL: "reports/loadSubTasksForTaskLeader.json",
			filterNodesURL: "reports/filterTasksForTaskLeader.json"
		});
		this.container.find(".focusOnDueDateField").click(() => {
			this.container.find(".dueDate").focus();
		});
	}

	private isNodeSelectable(data: Task & BaseTreeNodeData): boolean {
		return !data.dummy && data.currentUserIsLeader;
	}

	private lockPeriod(forceLock = false) {
		const taskId = this.taskDropdown.getSelectedId();
		if (!forceLock && !taskId) {
			BootstrapModal.confirm({
				title: "reports.lockTaskDialog.confirm.title",
				message: "reports.lockTaskDialog.confirm.message",
				yesLabel: "confirmation.lockAll",
				noLabel: "confirmation.cancel",
				yesAction: (modal: BootstrapModal.Modal) => {
					this.lockPeriod(true);
					modal.close();
				}
			});
		} else {
			const date = parseDateInput(this.container.find(".dueDate").val() as string);
			api("reports/lockTask.json")
				.post({
					"taskId": taskId,
					"dueDate": getISODate(date)
				})
				.done(() => {
					$(this).triggerHandler(LockTaskDialog.EVENT_TASK_LOCKED);
					this.hide();
				});
		}
	}

	private getDefaultDate(): Temporal.PlainDate {
		return Temporal.Now.plainDateISO().with({day: 1}).subtract({days: 1});
	}
}
